import { Directive } from '@angular/core';
import { PretragaKatalogaProviderDirective } from '@app/components';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TableListGridProviderDirective } from '@app/components/table-list-grid/directives/table-list-grid-provider.directive';
import {
  ListView,
  ListViewProviderDirective,
  ViewProviderDirective
} from '@ntap/core';
import { map, Observable } from 'rxjs';

@Directive({
  selector: '[appOdabirJediniceProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: OdabirJediniceZaRestauracijuProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: OdabirJediniceZaRestauracijuProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: OdabirJediniceZaRestauracijuProviderDirective
    },
    {
      provide: TableListGridProviderDirective,
      useExisting: OdabirJediniceZaRestauracijuProviderDirective
    },
    {
      provide: PretragaKatalogaProviderDirective,
      useExisting: OdabirJediniceZaRestauracijuProviderDirective
    }
  ],
  inputs: ['viewState', 'viewName']
})
export class OdabirJediniceZaRestauracijuProviderDirective extends PretragaKatalogaProviderDirective {
  override get view$(): Observable<ListView> {
    return super.view$.pipe(
      map((view: any) => {
        view.actions = view.actions.filter(
          (a: any) =>
            a.name === 'openJedinicaGradiva' || a.name === 'multiselect'
        );
        return view;
      })
    );
  }
}
